/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EWClient,
    EWClientFromJSON,
    EWClientFromJSONTyped,
    EWClientToJSON,
    MainDataVersion,
    MainDataVersionFromJSON,
    MainDataVersionFromJSONTyped,
    MainDataVersionToJSON,
} from './';

/**
 * 
 * @export
 * @interface MainDataResEWClient
 */
export interface MainDataResEWClient {
    /**
     * 
     * @type {MainDataVersion}
     * @memberof MainDataResEWClient
     */
    version: MainDataVersion;
    /**
     * 
     * @type {EWClient}
     * @memberof MainDataResEWClient
     */
    data?: EWClient;
    /**
     * 
     * @type {string}
     * @memberof MainDataResEWClient
     */
    error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResEWClient
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResEWClient
     */
    total?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MainDataResEWClient
     */
    limit?: number | null;
}

export function MainDataResEWClientFromJSON(json: any): MainDataResEWClient {
    return MainDataResEWClientFromJSONTyped(json, false);
}

export function MainDataResEWClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): MainDataResEWClient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'version': MainDataVersionFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : EWClientFromJSON(json['data']),
        'error': !exists(json, 'error') ? undefined : json['error'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function MainDataResEWClientToJSON(value?: MainDataResEWClient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'version': MainDataVersionToJSON(value.version),
        'data': EWClientToJSON(value.data),
        'error': value.error,
        'offset': value.offset,
        'total': value.total,
        'limit': value.limit,
    };
}


